import { PropsWithChildren } from "react";
import { Box, Stack, CircularProgress } from "@mui/material";
import { Link } from "react-router";
import {
  Body2Typography,
  H5Typography,
} from "../../../components/typography";

export const DesignFileListContainer = ({
  children,
  title,
  description,
  loading,
  count = 0,
  showViewAll = false,
  viewAllPath,
}: PropsWithChildren<{
  title: string;
  description?: string;
  loading: boolean;
  count?: number;
  showViewAll?: boolean;
  viewAllPath?: string;
}>) => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        p: 4,
        mb: 4,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 2, sm: 1 }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        mb={2}
      >
        <Box sx={{ maxWidth: "600px", flexGrow: 1 }}>
          <H5Typography sx={{ fontWeight: 600 }}>
            ({count}) {title}
          </H5Typography>
          {description && (
            <Body2Typography sx={{ color: "text.secondary", lineHeight: 1.5, mt: 0.5 }}>
              {description}
            </Body2Typography>
          )}
        </Box>
        {showViewAll && viewAllPath && (
          <Link
            to={viewAllPath}
            style={{
              color: "#5C3BFF",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: 600,
              whiteSpace: "nowrap",
              alignSelf: "flex-start",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = "underline";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = "none";
            }}
          >
            View All
          </Link>
        )}
      </Stack>

      <Box>{loading ? <CircularProgress sx={{ color: "#00A06D" }} /> : children}</Box>
    </Box>
  );
};
